import { FaArrowRight } from "react-icons/fa";

export default function FeatureCard({ icon, title, description, gradient, index = 0 }) {
  return (
    <div 
      className="group glass rounded-2xl p-8 border border-white/20 dark:border-white/10 shadow-sm hover:shadow-xl hover:border-white/30 dark:hover:border-white/20 transition-all duration-500 hover:-translate-y-2 cursor-pointer relative overflow-hidden"
      style={{ animationDelay: `${index * 100}ms` }}
    >
      {/* Hover gradient overlay */}
      <div className={`absolute inset-0 bg-gradient-to-br ${gradient} opacity-0 group-hover:opacity-5 dark:group-hover:opacity-10 transition-opacity duration-500`}></div>
      
      {/* Icon */}
      <div className={`relative w-16 h-16 bg-gradient-to-br ${gradient} rounded-2xl flex items-center justify-center mb-6 shadow-lg group-hover:scale-110 group-hover:shadow-xl transition-all duration-300`}>
        {icon}
        {/* Icon glow */}
        <div className={`absolute inset-0 bg-gradient-to-br ${gradient} rounded-2xl blur-xl opacity-0 group-hover:opacity-40 transition-opacity duration-300`}></div>
      </div>
      
      {/* Content */}
      <h3 className="relative text-xl font-bold mb-3 text-neutral-900 dark:text-white group-hover:text-neutral-800 dark:group-hover:text-neutral-100 transition-colors">
        {title}
      </h3>
      <p className="relative text-neutral-600 dark:text-neutral-400 leading-relaxed mb-4">
        {description}
      </p>
      
      {/* Learn more link */}
      <div className="relative flex items-center gap-2 text-sm font-semibold text-neutral-400 dark:text-neutral-500 group-hover:text-accent-600 dark:group-hover:text-accent-400 transition-colors">
        <span>Learn more</span>
        <FaArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" />
      </div>
    </div>
  );
}
